import "./plan-info.scss";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import { FONT_VARIANT, FONT_COLOR } from "../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../components/fonts/font-body3/font-body3";
import {IPlan, IPlanEditorModel} from "../../../../../models/Plan";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import IconInfo from "../../../../../components/icons/icon-info/icon-info";
import Icon from "../../../../../components/icons/icon/icon";
import {PLAN_CHARGE_TYPES} from "../../../stores/subscription-plan-editor-store";

interface IPlanInfoProps {
    plan?: IPlanEditorModel | IPlan;
    featuresInfo?: string;
}

interface IPlanInfoLableProps {
    color?: string;
    title?: string;
}

const PlanInfoLable: React.FC<IPlanInfoLableProps> = ({ color, title }) => {
    return (
        color && title
            ? <span className="plan-info-lable" style={{ backgroundColor: color }}>
                <FontBody3 color={FONT_COLOR.NEUTRAL_WHITE}>{title}</FontBody3>
            </span>
            : null
    );
}

const PlanInfoAdmin: React.FC<IPlanInfoProps> = ({ plan, featuresInfo}) => {
    return (
        <div className="plan-info" style={plan?.tag_color ? { borderColor: plan?.tag_color } : {}}>
            <PlanInfoLable title={plan?.tag} color={plan?.tag_color} />
            <div className="plan-info-name">
                <FontHeading4 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3}>
                    {plan?.name}
                </FontHeading4>
            </div>
            <div>
                <div>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        ${plan?.price}
                    </FontBody2>
                    <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                        /&nbsp;
                        { plan?.type === PLAN_CHARGE_TYPES.ANNUAL ? <span>year</span> : <span>month</span> }
                    </FontBody2>
                </div>
                <div>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        {plan?.rma_quota}
                    </FontBody2>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}> returns</FontBody2>
                </div>
            </div>
            <div>
                <div>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        ${plan?.price_per_extra_rma}
                    </FontBody2>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}> per extra return</FontBody2>
                </div>
                <div>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        ${plan?.capped_amount}
                    </FontBody2>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}> excess billing cap</FontBody2>
                </div>
            </div>
            <div>
                <div>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>Type: </FontBody2>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        {plan?.is_custom ? 'Custom' : 'Regular'}
                    </FontBody2>
                </div>
                <div>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>Trial days: </FontBody2>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        {plan?.trial_days}
                    </FontBody2>
                </div>
            </div>
            <div className="features-notes-column">
                <div>
                    <div>
                        <FontBody2 color={FONT_COLOR.PRIMARY2}>Features:&nbsp;</FontBody2>
                        {
                            !!plan?.features?.length ? (
                                <Tooltip content={featuresInfo}>
                                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                                        {plan?.features.length}
                                    </FontBody2>
                                </Tooltip>
                            ) : <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                                0
                            </FontBody2>
                        }
                    </div>
                    {
                        plan?.internal_name &&
                        <Tooltip content={plan?.internal_name}>
                            <Icon Component={IconInfo}/>
                        </Tooltip>
                    }
                </div>
            </div>
        </div>
    );
}

export default PlanInfoAdmin;
